import {
	Box,
	ButtonGroup,
	Icon,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
} from '@chakra-ui/react';
import { IconRefreshAlert } from '@tabler/icons';
import { AlertComponent } from 'components/alerts/AlertComponent';
import { ButtonComponent } from 'components/buttons/ButtonComponent';
import { useRecalculateRestrictedPlan } from 'pages/admin/capacity/restrictedPlan/hooks/useRecalculateRestrictedPlan';

import { ProcessType } from '../types/recalculateRestricted.dto';

interface IRecalculateRestrictedPlanModalProps {
	isOpen: boolean;
	onClose: () => void;
	cycleId: number | string;
	isSlow: boolean;
	onProcessRunningChange: () => void;
}

export const RecalculateRestrictedPlanModal = (
	props: IRecalculateRestrictedPlanModalProps
) => {
	const { isOpen, onClose, cycleId, isSlow, onProcessRunningChange } = props;

	const { mutateAsync } = useRecalculateRestrictedPlan(
		isSlow ?? false,
		onProcessRunningChange
	);

	const handleRecalculate = async () => {
		onClose();
		mutateAsync({
			cycleId: +cycleId,
			process_type: ProcessType.RECALCULATE_RESTRICTED_PLAN,
		});
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			size={'2xl'}
			isCentered
		>
			<ModalOverlay />
			<ModalContent borderRadius={'3xl'}>
				<ModalHeader>
					<Icon
						as={IconRefreshAlert}
						color={'easyRED.300'}
						boxSize={14}
					/>
					<Text
						fontWeight={700}
						color={'easyBLUE.300'}
						fontSize={'2xl'}
					>
						Recalcular Plano Restrito
					</Text>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Box mb={4}>
						<Text
							color={'secondaryGray.500'}
							fontWeight={400}
							fontSize={'md'}
							pb={4}
						>
							Deseja recalcular o plano restrito seguindo a saída
							do consenso da demanda, ou seja, plano irrestrito?
							<Text
								as={'span'}
								fontWeight={'bold'}
							>
								{' '}
								Note que ao recalcular você perderá as edições
								de plano restrito realizadas neste ciclo,{' '}
							</Text>
							retornando ao padrão mais recente do plano
							irrestrito deste ciclo
						</Text>
						<AlertComponent
							description='O recalculo do Plano Restrito será processado em segundo plano. Você poderá continuar usando o sistema enquanto processamos os dados. Isso pode levar alguns minutos.'
							status='info'
						/>
					</Box>
				</ModalBody>

				<ModalFooter>
					<ButtonGroup>
						<ButtonComponent
							type={'ghost'}
							title={'Cancelar'}
							onClick={onClose}
						/>
						<ButtonComponent
							type={'secondary'}
							title={'OK, entendi e desejo prosseguir'}
							onClick={handleRecalculate}
						/>
					</ButtonGroup>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};
